import { apiV2Client } from '../../../services/apiClient';
import { AssessmentResponseState, SaveLikertAnswerRequest } from '../models/assessmentResponse';

export const saveLikertAnswer = (request: SaveLikertAnswerRequest): Promise<AssessmentResponseState> => {
  return apiV2Client
    .post<AssessmentResponseState>('/assessment/command/SaveLikertAnswer', request)
    .then(({ data }) => data);
};
